export const logoClasses = {
  root: 'antl__logo__root',
};
